import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {User} from '../../graphql/auth';

interface UserData {
    user: User
}

export const gqlUser = `
  id
  email
  first_name
  last_name
  disabled
  created_at
  email_verified
  admin_verified
  email_opt_out
  sms_opt_out
  cellphone
  cellphone_code
  onetime_password

  roles {
    id
    ident
    name
    level
  }

  permissions {
    id
    ident
    name
  }

  permissionIdents

  associatedGroups {
    id
    name
    start_date
    end_date
    members {
      id
    }
    tour {
      id
      internal_name
    }
    hotel {
      id
      internal_name
    }
  }
`;

export const GET_USER_QUERY = gql`
    query getUser($id: Int!){
      user(id: $id) {
        ${gqlUser}
      }
    }
`;

export const getUser = (id: Number) => useQuery<UserData>(
    GET_USER_QUERY,
    {
        variables: {id}
    }
);

export default getUser;
